import React from 'react'
import './customer.experience_401.scss'
import { Container } from 'react-bootstrap';
import VideoPlayer from '../../layout/videoplayer';

const CustomerExperience401 = () => {
    return (
        <div className='customer_experience_401'>
            <div className='Thank-you-wrapper'>
                <Container>
                    <div className='top-details'>
                        <h3>401(k) customer experiences</h3>
                        <p>Our customers are at the heart of everything we do at Sentry. The relationship we’ve built with Spectra Print over the years is just one example of our customer service.</p>
                    </div>
                    <div className='vdo_section'>
                        <div className='videos'>
                            <VideoPlayer videoSrc="https://www.w3schools.com/html/mov_bbb.mp4" />
                        </div>
                        <div className='italic_text'>
                            <div className='text'>
                                "Sentry has so many resources for me as the administrator of the plan. Everyone there is very informed."
                            </div>
                            <div className='author'>Heidi Okray</div>
                            <div className='small_description'>Retirement Plan Manager at Spectra Print</div>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default CustomerExperience401;
